import { z } from 'zod';

/////////////////////////////////////////
// MOBILE BUTTONS SCHEMA
/////////////////////////////////////////

export const MobileButtonsSchema = z.object({
  mobilebuttonId: z.number().int(),
  cityId: z.number().int(),
  icon: z.string(),
  label: z.string(),
  action: z.string(),
  URL: z.string(),
  mobileOrder: z.number().int(),
})

export type MobileButtons = z.infer<typeof MobileButtonsSchema>

export default MobileButtonsSchema;
